import React from 'react';
import { FaGithub, FaFacebookF, FaLinkedinIn, FaBlog } from 'react-icons/fa';
import { SiX } from 'react-icons/si';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          &copy; {new Date().getFullYear()} - Developed by Khandaker Atik
        </p>
        <div className="footer-socials">
          <a
            href="https://github.com/Khandaker-Atik"
            target="_blank"
            rel="noreferrer"
            className="github"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://linkedin.com/in/atikur-rahman007"
            target="_blank"
            rel="noreferrer"
            className="linkedin"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://www.facebook.com/therealatik"
            target="_blank"
            rel="noreferrer"
            className="facebook"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://x.com/Atik_Khandaker"
            target="_blank"
            rel="noreferrer"
            className="x"
            aria-label="X"
          >
            <SiX />
          </a>
          <a
            href="https://khandaker-atik.blogspot.com"
            target="_blank"
            rel="noreferrer"
            className="blog"
            aria-label="Blog"
          >
            <FaBlog />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
